import {
  taskAssignmentApiClient,
  taskDefinitionApiClient,
} from 'src/api/ProactApiClientInstances';
import {registerTasksOffline} from 'src/app/tasks/registerTasksOffline';

// Composition root for tasks offline replay: binds the API client to the domain
// registration in src/app, which may not import the client itself.
registerTasksOffline({
  getOfflineBundle: () => taskAssignmentApiClient.getOfflineBundle(),
  getAssignment: id => taskAssignmentApiClient.details(id),
  transitionAssignment: (id, request) =>
    taskAssignmentApiClient.transitionAssignment(id, request),
  getAssignmentStateMachine: () =>
    taskAssignmentApiClient.getAssignmentStateMachine(),
  getDefinitionStateMachine: () =>
    taskDefinitionApiClient.getDefinitionStateMachine(),
  createDefinition: request => taskDefinitionApiClient.create(request),
  getDefinition: id => taskDefinitionApiClient.getDetails(id),
  transitionDefinition: (id, request) =>
    taskDefinitionApiClient.transitionDefinition(id, request),
});
